/*
 * @Descripttion: radio双层单选组件
 */

import React, { useEffect, useState } from 'react';
import { Balloon, Input, Radio } from '@alifd/next';
import styles from './index.module.scss';

/**
 * opType 固定为 'EQ'
 * @param {*} tagItem 整个标签的信息
 * @param {*} changeData 把组件的值提交到父组件，改变父组件的值
 * @return {*}
 */
const TagRadioDouble = ({
  tagItem = {},
  changeData = (data) => {},
  pageType = ''
}) => {
const [data, setData] = useState(tagItem?.opValue?.param_list?.[0]?.param_id?.[0]); // radio选中的值
const [insideData, setInsideData] = useState(tagItem?.opValue?.param_list?.[0]?.subOpValue?.param_id?.[0]); // radio选中的值
const [idArr, setIdArr] = useState(tagItem?.opValue?.param_list?.[0]?.subOpValue?.extra_map.join(','));
/**
 * 选择时改变要处理成字符串形式传给父组件
 */
  const changeValue = (val) => {
    setData(val);
    setInsideData('');
    setIdArr('');
    changeData({
      opValue: {
        label_id: tagItem.id,
        param_list: [
          {
            param_id: [val],
            subOpValue:{
              param_id: [''],//ID类型
              extra_map:[],//手动输入的ID
            }
          }
        ]
      },
      opType: 'EQ'
    });
  };
/**
 * 选择时改变要处理成字符串形式传给父组件
 */
  const changeInsideValue = (val) => {
    setInsideData(val);
    setIdArr('');
    changeData({
      opValue: {
        label_id: tagItem.id,
        param_list: [
          {
            param_id: [data],
            subOpValue:{
              param_id: [val],//ID类型
              extra_map:[],//手动输入的ID
            }
          }
        ]
      },
      opType: 'EQ'
    });
  };
  const changeInsideId = (val) => {
    setIdArr(val);
    changeData({
      opValue: {
        label_id: tagItem.id,
        param_list: [
          {
            param_id: [data],
            subOpValue:{
              param_id: [insideData],//ID类型
              extra_map:[...val.split(',')],//手动输入的ID
            }
          }
        ]
      },
      opType: 'EQ'
    });
  };

  useEffect(()=>{
    if( pageType==='1' || (pageType ==='2' && !tagItem.opValue)) { // 如果是创建
      if(tagItem.id === '2131' || tagItem.id === '2141') { 
        // 如果为[近期在直播间下单sku-直播间类型] || [近期在短视频内下单sku-短视频类型]
        changeValue('1');
      }
    }
  },[pageType])
  return (
    <div className={`${styles['tag-checkbox']} tag-width`}>
      <div className={styles['tag-radio']}>
        <div style={{color:'#ff3333'}}>*</div>
        <div>
          {tagItem.labelName}
        </div>
        :
        <Radio.Group value={data} onChange={(val) => changeValue(val)}>
        {
          tagItem.value.map((its, ins) => (<Radio
            style={{ marginBottom: '10px', marginLeft: '0px', marginRight: '8px' }}
            key={ins}
            value={its.realValue}
          >
            {its.fieldValue}
          </Radio>))
        }
      </Radio.Group>
      </div>
      {
        data && 
        <div className={styles['infoBox']} style={{marginLeft:94+102*(data-1)}}>
          <div>
            <span>
              ID类型：
            </span>
            <Radio.Group value={insideData} onChange={(val) => changeInsideValue(val)}>
              {
                tagItem?.value[data-1].param_list.map((secIt,secInx)=>(
                  <Radio
                    key={`secIt_its_${secInx}`}
                    style={{ marginBottom: '10px', marginLeft: '0px', marginRight: '8px' }}
                    value={secIt.realValue}
                  >
                  {secIt.fieldValue}
                  </Radio>
                ))
              }
            </Radio.Group>
            <div style={{margin:'0 0 5px 47px', color: "#f33" }}>不限制类型，默认统计全部{tagItem?.value[data-1].fieldValue}</div>
          </div>
          <div>
            <span>
              ID：
            </span>
            <Input
              disabled={+insideData===1}
              style={{width:'250px'}}
              placeholder='多个id,请用英文逗号隔开'
              value={idArr}
              onChange={(val) => changeInsideId(val)}
            />
          </div>
        </div>
      }
      {
        !data && <div style={{ color: "#f33" }}
          className={`iconfont icon-icon4-30 ${styles['tag-error-select']}`}
        >请选择{tagItem.labelName}
        </div>
      }
    </div>
  );
}

export default TagRadioDouble;
